
@if (FC) {
  <textarea pInputTextarea rows="1" [autoResize]="true" [formControl]="FC" [placeholder]="placeholder ?? ''" type="text" class="input-autosize input-subtle {{variantClass}}"></textarea>

}
